const datatable = {
  display_config: {
    display: "Hiển thị",
    per_total_records: "trong tổng số {total} bản ghi",
  },
  buttons: {
    add: "Thêm mới",
    delete: "Xóa đang chọn"
  },

}

const filter = {
  item: {
    title: "Lọc theo từ khoá",
    status: "Lọc theo trạng thái",
  },
  placeholder: {
    title: "Nhập tiêu đề bài viết",
    status: "Chọn trạng thái",
  },
  status: {
    all: "Tất cả",
    draft: "Nháp",
    published: "Đã xuất bản",
    pending: "Chờ duyệt",
    trash: "Thùng rác",
  }
}

export default {
  account: {
    datatable,
    filter
  }
}
